import React, { useRef } from 'react';
import { useForm } from 'react-hook-form';
import { formatPhoneNumber } from '../utils/formatters';

interface PhoneFormProps {
  isLoading: boolean;
  sendOtp: (phone: string) => void;
}

interface PhoneFormData {
  phone: string;
}

const PhoneForm: React.FC<PhoneFormProps> = ({ isLoading, sendOtp }) => {
  const isLoadingRef = useRef(false);
  const phoneForm = useForm<PhoneFormData>({
    defaultValues: {
      phone: '010-',
    }
  });

  // phone 필드 값을 실시간으로 감시
  const phoneValue = phoneForm.watch('phone');

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    phoneForm.setValue('phone', formatPhoneNumber(value));
  };

  const handleSubmit = (data: PhoneFormData) => {
    if (isLoadingRef.current) return;
    
    isLoadingRef.current = true;
    sendOtp(data.phone);
    
    // 성공/실패 관계없이 일정 시간 후 잠금 해제
    setTimeout(() => {
      isLoadingRef.current = false;
    }, 3000);
  };

  return (
    <form onSubmit={phoneForm.handleSubmit(handleSubmit)} className="w-full space-y-4">
      <div>
        <label>휴대전화 번호</label>
        <input
          type="tel"
          inputMode='tel'
          id="phone"
          autoFocus
          {...phoneForm.register('phone', { 
            required: '전화번호를 입력해주세요',
            pattern: {
              value: /^010-\d{4}-\d{4}$/,
              message: '올바른 전화번호 형식이 아닙니다'
            }
          })}
          onChange={handlePhoneChange}
          placeholder="010-1234-5678"
          className="w-full"
        />
        {phoneForm.formState.errors.phone && (
          <p className="mt-1 ml-2 text-sm text-red-500">{phoneForm.formState.errors.phone.message}</p>
        )}
      </div>
      <button
        type="submit"
        disabled={isLoading || phoneValue.length < 13}
        className="w-full flex justify-center py-3.5 px-4 border border-transparent rounded-xl font-bold text-white bg-blue-500 cursor-pointer"
      >
        {isLoading ? '처리중...' : '인증번호 받기'}
      </button>
    </form>
  );
};

export default PhoneForm; 